import {
  BREAKPOINT_LARGE,
  BREAKPOINT_MEDIUM,
  BREAKPOINT_SMALL,
  BREAKPOINT_TINY,
} from 'views/consts/breakpoints'
import cssVars from 'views/utils/cssVars'

export const CONTENT_MAX_WIDTH = cssVars.content['content-max-width']
const BREAKPOINT_CONTENT_MAX = `(min-width: ${CONTENT_MAX_WIDTH})`

export const BASE_BREAKPOINT = 'base'
export const MAX_CONTENT_BREAKPOINT = 'max-content'

export const BREAKPOINT_MAP = {
  [MAX_CONTENT_BREAKPOINT]: BREAKPOINT_CONTENT_MAX,
  large: BREAKPOINT_LARGE.replace('screen and ', ''),
  medium: BREAKPOINT_MEDIUM.replace('screen and ', ''),
  small: BREAKPOINT_SMALL.replace('screen and ', ''),
  tiny: BREAKPOINT_TINY.replace('screen and ', ''),
} as const

export const BREAKPOINTS = Object.keys(BREAKPOINT_MAP)
